import { get } from 'svelte/store';
import { filterStores } from '../../state';
import type { FilterDrawerCollection, FilterDrawerState, FilterSections } from '../../types';
import { resolveFilterFacets } from '../getFilterTrackEvents/getFilterTrackEvents';
import { isEmptyValue } from '../getFilterValueLabel/getFilterValueLabel';

// Every facet currently narrowing the grid, as a flat `{ facet: label }` map.
// `getActiveArtist` answers "which artist?"; this answers "under what filters
// was this seen?" — the context HB-973 wants alongside a card click, so a
// select_item can be read against the filter state that produced the grid.
export const getActiveFilters = ({
	filter,
	filterSections
}: {
	filter: FilterDrawerState;
	filterSections: FilterSections;
}): Record<string, string> => {
	const collections = Object.values(filter || {}).filter(
		(collection): collection is FilterDrawerCollection =>
			!!collection && !isEmptyValue(collection.value)
	);

	return resolveFilterFacets({ collections, filterSections }).reduce(
		(acc, { filterType, filterValue }) => {
			if (!filterValue) return acc;

			return { ...acc, [filterType]: filterValue };
		},
		{} as Record<string, string>
	);
};

// Store-backed convenience wrapper, mirroring `getActiveArtistFromStores`, for
// callers (grid cards) that fire outside the filter drawer and hold no filter state.
export const getActiveFiltersFromStores = (): Record<string, string> =>
	getActiveFilters({
		filter: get(filterStores.filterStore),
		filterSections: get(filterStores.filterSectionsStore)
	});
